module.exports = __webpack_public_path__ + "img/logo11-frame.10fd19e4.png";